import { useMemo } from "react";
import { createPortal } from "react-dom";
import CommonButton from "../../../components/commonButton";
import { ArrowLeftIcon, PlusIcon } from "../../../assets/icons";
import StatusChip from "../../../components/statusChip/StatusChip";
import { useNavigate, useLocation } from "react-router-dom";
import { BankIcons, goBack } from "../../../utils/otherHelopers";
import { routes } from "../../../routes/pageRoutes";
import { TableSearch } from "../../../components/form/Fields";
import CustomTable from "../../../components/table/CustomTable";

export default function DetailList({
  data,
  isLoading,
  isInitialLoad,
  setCurrentPage,
  detailSearchBar,
  setDetailSearchBar,
  setOpenAddBranchModal,
  handleStatusToggle,
  handleEdit,
  handleView,
  canCreate,
  canUpdate,
  pagination,
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const headerPortalTarget = document.getElementById("header-portal-target");

  const handleBack = () => {
    sessionStorage.removeItem("bankDetails_searchTerm");
    sessionStorage.removeItem("bankDetails_limit");
    sessionStorage.removeItem("bankDetails_page");
    goBack(navigate, location, routes.banks);
  };

  const renderHeaderContent = () => (
    <div className="d-flex align-items-center justify-content-between w-100">
      <div className="d-flex align-items-center gap-2">
        <button
          onClick={handleBack}
          type="button"
          className="border-0 bg-transparent p-0 d-flex align-items-center justify-content-center primary"
        >
          <ArrowLeftIcon size={22} />
        </button>
        <h4 className="fw-semibold mb-0 text-primary fs-lg">
          Bank
        </h4>
      </div>
    </div>
  );

  const columns = useMemo(
    () => [
      {
        id: "sr_no",
        header: "SR NO.",
        cell: (_, row, index) => {
          const page = pagination?.currentPage || 1;
          const size = pagination?.pageSize || 10;
          return (page - 1) * size + index + 1;
        },
      },
      {
        id: "branch_name",
        header: "BRANCH NAME",
        cell: (_, row) => (
          <div className="d-flex align-items-center gap-2">
            {row?.name ? BankIcons(row?.name) : "-"}
            <span>{row.name}</span>
          </div>
        ),
      },
      {
        id: "branch_city",
        header: "BRANCH CITY",
        cell: (_, row) => row.city || "-",
      },
      {
        id: "status",
        header: "STATUS",
        cell: (_, row) => (
          <StatusChip
            bg={row?.is_active ? "success" : "danger"}
            pill
            title={row?.is_active ? "Active" : "Inactive"}
            className={canUpdate ? "cursor-pointer" : ""}
            onClick={(e) => {
              e.stopPropagation();
              if (canUpdate) {
                handleStatusToggle(row);
              }
            }}
          />
        ),
      },
    ],
    [canUpdate, handleStatusToggle, pagination],
  );

  const actionList = useMemo(
    () =>
      [
        {
          title: "View",
          handler: (row) => {
            handleView(row);
          },
        },
        canUpdate && {
          title: "Edit",
          handler: (row) => {
            handleEdit(row);
          },
        },
        canUpdate && {
          title: (row) => (row.is_active ? "Deactivate" : "Activate"),
          handler: (row) => {
            handleStatusToggle(row);
          },
        },
      ].filter(Boolean),
    [canUpdate, handleView, handleEdit, handleStatusToggle],
  );

  const isTableLoading = !isInitialLoad && isLoading;

  return (
    <>
      {headerPortalTarget && createPortal(renderHeaderContent(), headerPortalTarget)}
      <div className="p-4 d-flex align-items-center justify-content-between gap-4">
        <TableSearch
          value={detailSearchBar}
          placeholder="Search by Branch Name"
          onChange={(e) => {
            setDetailSearchBar(e.target.value);
            setCurrentPage(1);
          }}
        />

        {canCreate && (
          <CommonButton
            onClick={() => setOpenAddBranchModal(true)}
            icon={<PlusIcon size={14} />}
            variant="primary"
            title="Add Branch"
          />
        )}
      </div>

      <CustomTable
        data={data}
        columns={columns}
        loading={isTableLoading}
        keyField="id"
        emptyMessage="No branches found"
        actionList={actionList}
        pagination={pagination}
      />
    </>
  );
}
